import * as React from "react";
import { singleton } from "logic/singleton";
const DocumentTitleContext = React.createContext(void 0);
export default singleton("contexts.DocumentTitleContext", () => DocumentTitleContext);
